export const GET_ACTIVE_USERS = 'admin/GET_ACTIVE_USERS';
export const GET_ACTIVE_USERS_SUCCESS = GET_ACTIVE_USERS+'_SUCCESS';
export const GET_ACTIVE_USERS_FAILURE = GET_ACTIVE_USERS+'_FAILURE';
export const GET_RETENTION = 'admin/GET_RETENTION';
export const GET_RETENTION_SUCCESS = GET_RETENTION+'_SUCCESS';
export const GET_RETENTION_FAILURE = GET_RETENTION+'_FAILURE';

